<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: { type: Number, required: true },
  min: { type: Number, default: 0.1 },
  max: { type: Number, default: 3 },
  step: { type: Number, default: 0.01 },
});

const emit = defineEmits(["update:modelValue"]);

function updateSliderValue(clientX: number, rect: DOMRect) {
  const percent = (clientX - rect.left) / rect.width;
  const rawValue = props.min + percent * (props.max - props.min);
  const stepped = Math.round(rawValue / props.step) * props.step;
  emit("update:modelValue", Math.min(props.max, Math.max(props.min, stepped)));
}

function enableListeners(rect: DOMRect) {
  const move = (ev: MouseEvent) => updateSliderValue(ev.clientX, rect);
  const up = () => {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", up);
  };

  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", up);
}

function onClickTrack(e: MouseEvent) {
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
  updateSliderValue(e.clientX, rect);
  enableListeners(rect);
}

function onThumbDown(e: MouseEvent) {
  const track = (e.currentTarget as HTMLElement).parentElement as HTMLElement;
  const rect = track.getBoundingClientRect();
  enableListeners(rect);
}
</script>

<template>
  <div class="w-full h-6 flex items-center">
    <!-- Track -->
    <div
      class="relative w-full h-2 bg-hover border border-muted rounded cursor-pointer"
      @mousedown="onClickTrack"
    >
      <!-- Filled part -->
      <div
        class="absolute top-0 left-0 h-2 bg-muted rounded-l"
        :style="{ width: ((modelValue - min) / (max - min)) * 100 + '%' }"
      ></div>

      <!-- Thumb -->
      <div
        class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-brown cursor-pointer"
        :style="{ left: ((modelValue - min) / (max - min)) * 100 + '%' }"
        @mousedown="onThumbDown"
      ></div>
    </div>
  </div>
</template>
